import {
  Button,
  Card,
  Stack,
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import OpenGraphGeneral from '../components/MetaData/OpenGraphGeneral';

export default function GeneralError() {
  const theme = useTheme();
  const showImage = useMediaQuery(theme.breakpoints.up('md'));
  const { t } = useTranslation();

  return (
    <Card variant='outlined'>
      <Grid
        container
        sx={{
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Grid
          size={{
            xs: 12,
            md: 8,
            lg: 8,
          }}
        >
          <Stack
            direction='column'
            sx={{
              height: '100%',
              justifyContent: 'center',
              paddingY: { xs: 3 },
              paddingX: { xs: 2, sm: 3, md: 6 },
            }}
          >
            <Typography
              variant='h2'
              sx={{
                marginY: 1,
              }}
            >
              {t('error.title')}
            </Typography>
            <Typography
              variant='body2'
              sx={{
                marginY: 1,
              }}
            >
              {t('error.content')}
            </Typography>
            <Box>
              <Button
                variant='text'
                size='large'
                endIcon={<ArrowForward fontSize='small' />}
                href='/'
                sx={{ textDecoration: 'none', textTransform: 'none' }}
              >
                {t('error.goToHomePage')}
              </Button>
            </Box>
          </Stack>
        </Grid>
        {showImage && (
          <Grid
            size={{
              xs: 12,
              md: 4,
              lg: 4,
            }}
            sx={{
              width: '100%',
            }}
          >
            <Box
              component='img'
              sx={{
                height: '100%',
                width: '100%',
              }}
              alt='Error Background'
              src='/error_bg.jpg'
            />
          </Grid>
        )}
      </Grid>
      <OpenGraphGeneral />
    </Card>
  );
}
